/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function FloppyDiskBack(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M208,40.00012H91.31372a8.00052,8.00052,0,0,0-5.657,2.343L42.34326,85.65686A7.99918,7.99918,0,0,0,40,91.3136V208.00012a8.00009,8.00009,0,0,0,8,8H208a8.00009,8.00009,0,0,0,8-8v-160A7.99993,7.99993,0,0,0,208,40.00012ZM128.00586,176.00891a28,28,0,1,1,28-28A28,28,0,0,1,128.00586,176.00891Z"
        opacity={0.2}
      />
      <Path
        d="M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Circle
        cx={128.0059}
        cy={148.009}
        r={28}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="96 80.009 160 80.009 160 40.009"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default FloppyDiskBack;
